import styled from 'styled-components'

export const animationClasses = {
  left: 'animation-left',
  right: 'animation-right',
  center: 'animation-center',
}

export const imageSize = 300
export const mobileImageSize = 200

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  overflow: hidden;

  & > div {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    height: ${imageSize}px;
    width: ${imageSize}px;
    pointer-events: none;
    background-position: center;
  }

  ${`.${animationClasses.left}`} {
    animation: animation-left 1s;
    visibility: unset;
  }

  ${`.${animationClasses.right}`} {
    animation: animation-right 1s;
    visibility: unset;
  }

  ${`.${animationClasses.center}`} {
    animation: animation-center 1s;
    visibility: unset;
  }

  @media (max-width: 500px) {
    & > div {
      height: ${mobileImageSize}px;
      width: ${mobileImageSize}px;
    }
  }

  @keyframes animation-left {
    0% {
      transform: translate(0, 0) scale(0.2);
      opacity: 1;
    }
    10% {
      transform: scale(1);
    }
    60% {
      opacity: 1;
    }
    100% {
      transform: translate(-50px, 200px);
      opacity: 0;
      z-index: 0;
    }
  }

  @keyframes animation-right {
    0% {
      transform: translate(0, 0) scale(0.2);
      opacity: 1;
    }
    10% {
      transform: scale(1);
    }
    60% {
      opacity: 1;
    }
    100% {
      transform: translate(50px, 200px);
      opacity: 0;
    }
  }

  @keyframes animation-center {
    0% {
      transform: translate(0, 0) scale(0.2);
      opacity: 0;
    }
    10% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(10px, 200px) scale(1);
      opacity: 0;
    }
  }
`
